import { Alert, Table } from "flowbite-react";
import TitleStripe from "../TitleStripe";
import NoOcurrence from "./NoOcurrence";
import { formatToReal } from "../../../utils/utils";
import moment from "moment";

const ProtestoNacional = ({ data }) => {
  return (
    <>
      <TitleStripe>Protesto nacional</TitleStripe>
      {data?.statusRetorno == 1 ? (
        <>
          {data?.total_protestos == 0 ? (
            <NoOcurrence />
          ) : (
            <>
              {data?.protestos_por_estados?.length > 0 ? (
                <>
                  {data?.protestos_por_estados?.map((estado, index) => (
                    <div key={index} className="mt-2">
                      <div className="grid grid-cols-3 gap-2 mb-2">
                        <div className="underline">
                          <span className="font-semibold inline-block mr-1 underline">
                            Estado:
                          </span>
                          {estado?.estado}
                        </div>
                      </div>
                      {estado?.protestos_por_cartorio?.map((cidade, idxC) => (
                        <div key={idxC} className="mb-3">
                          <div className="grid grid-cols-3 gap-2 mb-2 text-sm">
                            <div>
                              <span className="font-semibold inline-block mr-1">
                                Cartório:
                              </span>
                              {cidade?.cartorio}
                            </div>
                            <div>
                              <span className="font-semibold inline-block mr-1">
                                Cidade:
                              </span>
                              {cidade?.cidade}
                            </div>
                            <div>
                              <span className="font-semibold inline-block mr-1">
                                Total de protestos:
                              </span>
                              {cidade?.total_protestos}
                            </div>
                          </div>
                          <div className="overflow-hidden rounded-md">
                            <Table striped className="w-full">
                              <Table.Head>
                                <td className="bg-primary px-2 py-1 font-semibold text-2xs text-white">
                                  Data
                                </td>
                                <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                  Documento
                                </td>
                                <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                                  Valor
                                </td>
                              </Table.Head>
                              <Table.Body>
                                {cidade?.protestos?.map((address, index) => (
                                  <tr
                                    key={index}
                                    className={`${
                                      index % 2 === 0
                                        ? "bg-gray-100"
                                        : "bg-white"
                                    }`}
                                  >
                                    <td className="px-2 py-1">
                                      {moment(address?.data_protesto).format(
                                        "DD/MM/yyyy"
                                      )}
                                    </td>
                                    <td className="p-1 text-center">
                                      {address?.documento_devedor}
                                    </td>
                                    <td className="p-1 text-center font-semibold text-red-500">
                                      {formatToReal(address?.valor_protesto)}
                                    </td>
                                  </tr>
                                ))}
                              </Table.Body>
                            </Table>
                          </div>
                        </div>
                      ))}
                    </div>
                  ))}
                </>
              ) : (
                <NoOcurrence />
              )}
            </>
          )}
        </>
      ) : (
        <Alert className="mt-2" color="gray" withBorderAccent>
          Consulta indisponível no momento!
        </Alert>
      )}
    </>
  );
};

export default ProtestoNacional;
